/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/product-card';

export const styles = {
  skillsContainer: css`
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
  `,
  skillsYoullGain: () => css`
    color: var(--cds-color-grey-975);
  `,
};

type Props = {
  skills?: string[];
};

const ProductCardSkills = ({ skills }: Props) => {
  if (!skills?.length) {
    return null;
  }
  return (
    <Typography2 component="p" variant="bodySecondary" color="supportText" css={styles.skillsContainer}>
      <span css={styles.skillsYoullGain}>
        <b>{_t("Skills you'll gain: ")}</b>
      </span>
      {skills.join(', ')}
    </Typography2>
  );
};

export default ProductCardSkills;
